export default () => {
  const menuItems = document.getElementById('primary-menu').children
  Array.prototype.forEach.call(menuItems, (item) => {
    if (item.firstChild.innerText)
      item.firstChild.setAttribute('name', item.firstChild.innerText)
  })
}
